export default function CVariableValues() {
  return <h2>C Variable Values</h2>;
}
